module.exports = __webpack_public_path__ + "static/4-ae0ee6c27e4e1c4cb061b424d0df2562.jpeg";